<template>
  <div
    class="page flex-col"
    style="
      background-image: url(/static/img/background-login.jpg);
      background-size: cover;
    "
    v-loading="loading"
  ></div>
</template>
<script>
import eventBus from "@/utils/eventBus.js"

import {
  platformLogin, getInfo
} from "@/api/api"
export default {
  components: {
    // VueQr,
    // wxlogin
  },
  data () {
    return {
      appkey: "",
      clientTime: "",
      data: "",
      hashcode: "",
      backUrl: "",
      userInfo: {},
      loading: true,
      baseUrl: window.__baseUrl__,
    }
  },
  created () {


  },
  mounted () {
    const { appKey, clientTime, data, hashCode } = this.$route.query
    if (!clientTime || !appKey || !data || !hashCode) {
      this.$message.error("缺少參數")
      return false
    }
    this.clientTime = clientTime
    this.appkey = appKey
    this.data = data
    this.hashcode = hashCode
    this.pLogin()
  },
  methods: {
    pLogin () {
      // const {appkey,clientTime,data,hashcode} = this
      // let params={
      //   "appkey":"rulib",
      //   "clientTime":"1703577775088",
      //   "data":"adbf3ab94233e4ac56acc8be8deae6890789a4730af14ae0cc7b863ea9505ac619c71679ca1434428235f5b46ec02162",
      //   "hashcode":"a40ed496f816aa4c69e3b17b7bce67e9b1b65c2309f3df3eb0d96dc32758ec09"
      // }
      let params = {
        "clientTime": this.clientTime,
        "appKey": this.appkey,
        "data": this.data,
        "hashCode": this.hashcode
      }
      // let params={appkey,clientTime,data,hashcode}
      platformLogin(params).then(res => {
        // console.log(res, 'res')
        if (res.code == 200) {
          localStorage.setItem("token", "Bearer " + res.token)
          eventBus.$emit("getUserInfo")
          this.backUrl = res.backUrl ? decodeURIComponent(res.backUrl) : ''
          this.loading = false
          // window.location.href = "https://test.rulib.cn/#/bookDetail?id=214"
          if (this.backUrl) {
            let curpatharr = this.backUrl.split("/")
            let curpathnum = curpatharr.length
            let gopath = curpathnum <= 3 ? '/' : '/' + curpatharr[curpathnum - 1]
            this.$router.replace({ path: gopath })

          } else {
            this.$router.replace({ path: "/" })

          }
          // eventBus.$emit("openBindMobile") 总平台用户不弹窗绑手机号

          // this.$message.success("登録成功")总平台用户不提示登录成功


        } else {
          this.$message.error(res.msg)
        }
      })

    }


  }
};
</script>
<style lang="less" scoped>
.page {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: rgba(245, 245, 245, 1);
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Courier New", Courier, monospace;
}
</style>



// WEBPACK FOOTER //
// src/pages/platformlogin.vue